import { useQuery } from "@tanstack/react-query";
import { useEffect } from "react";
import { enumerationQueryOptions } from "../../common/api/queries";
import { EnumerationType } from "../enumerations/enums";
import { brandingActions } from "./store";

/** Mirrors the branding query into the store, also when it comes restored from the persisted cache. */
export const useBrandingSync = () => {
  const { data } = useQuery(enumerationQueryOptions(EnumerationType.BRANDING));

  useEffect(() => {
    brandingActions().setBranding(data ?? undefined);
  }, [data]);
};
